<template>
    <v-card class="layout column notification-modal calendar-modal" :style="$vuetify.breakpoint.smAndUp ? 'width:520px' : ''">
        <closeButton icon_name="close" class="notifications__modal-btn modal-btn" @click.native="$emit('close')" />
        <v-layout column class="notifications__wrap">
            <div>
                <v-flex class="notifications">
                    <div class="notifications__modal-title-wrap">
                        <h2 class="notifications__modal-title new">{{ $t("новые уведомления") }}</h2>
                    </div>
                    <notificationRecordModal v-for="(notification, i) in new_notes" :key="i" wrap
                                             :info="notification"
                                             justify-space-around
                                             align-start
                                             class="notifications_block"
                                             @click.native="goto_new(notification.notification_id)"
                    />
                </v-flex>
            </div>
            <div>
                <v-flex class="notifications">
                    <div class="notifications__modal-title-wrap">
                        <h2 class="notifications__modal-title">{{ $t("прочитанные уведомления") }}</h2>
                    </div>
                    <notificationRecordModal v-for="(notification, i) in old_notes" :key="i" wrap
                                             :info="notification"
                                             justify-space-around
                                             align-start
                                             class="notifications_block"
                                             @click.native="goto_old(notification.notification_id)"
                    />
                </v-flex>
            </div>
            <v-layout wrap>
                <v-flex ld6 md6 xs12>
                    <buttonRed class="notifications__modal-btns" @click.native="goto_note">{{ $t("показать все") }}</buttonRed>

                </v-flex>
                <v-flex ld6 md6 xs12>
                    <buttonBdWhite class="notifications__modal-btns" @click.native="goto_edit">{{ $t("Настроить уведомления") }}</buttonBdWhite>
                </v-flex>
            </v-layout>
        </v-layout>
    </v-card>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex';
import CloseButton from '@/components/ui/buttons/buttons_icon/close_button';
import buttonRed from '@/components/ui/buttons/button_red';
import notificationRecordModal from '@/components/blocks/Notifications/notification_record_modal.vue';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import dayjs from 'dayjs';

export default {
  components: {
    CloseButton,
    buttonRed,
    buttonBdWhite,
    notificationRecordModal,
  },
  computed: {
    ...mapGetters('notifications/Notifications_items', [
      'notifications',
    ]),
    new_notes() {
      let a = this.notifications.filter((x) => x.new == true);
      return a.splice(0, 5);
    },
    old_notes() {
      let a = this.notifications.filter((x) =>{
        return x.new !== true;
      });
      return a.splice(0, 3);
    },
  },
  mounted() {
    let ids = this.new_notes.map((item) => item.notification_id);
    /* this.set_read_notes(ids);*/
  },
  destroyed() {
    /* this.new_notes.map((item) => {
      this.SET_READ_MESSAGE(item);
    });*/
  },
  beforeCreate() {
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.paddingRight = '15px';
    document.querySelector('nav').style.paddingRight = '15px';
  },
  beforeDestroy() {
    document.documentElement.style.overflow = 'auto';
    document.documentElement.style.paddingRight = '0px';
    document.querySelector('nav').style.paddingRight = '0';
  },
  methods: {
    ...mapActions('notifications/Notifications_items', [
      'set_read_notes',
    ]),
    ...mapMutations('notifications/Notifications_items', [
      'SET_READ_MESSAGE',
    ]),
    goto_note() {
      this.$router.push({name: 'notifications'});
      this.$store.state.isNew = true;
      this.$store.state.isOld = false;
      this.$emit('close');
    },
    goto_edit() {
      this.$router.push({name: 'note_edit'});
      this.$emit('close');
    },
    goto_new(id) {
      this.$store.state.id = id;
      this.$router.push({name: 'notifications'});
      this.$store.state.isOld = false;
      this.$store.state.isNew = true;
      this.$emit('close');
    },
    goto_old(id) {
      this.$store.state.id = id;
      this.$router.push({name: 'notifications', hash: '#' + id});
      this.$store.state.isOld = true;
      this.$store.state.isNew = false;
      this.$emit('close');
    },
  },
};
</script>
